import React from "react";
import PropTypes from "prop-types";

import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import Checkbox from "@mui/material/Checkbox";
import { Autocomplete, Chip, Stack, TextField, Typography } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import ButtonGroup from "@mui/material/ButtonGroup";
import { responsiveValue } from "../../../theme/Styles/responsiveValue";
import { AddressData } from "../../../common/enum/addressData";
import Tooltip from "@mui/material/Tooltip";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    overflow: "visible",
    minWidth: 200,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 22px",
  border: "2px solid",
  lineHeight: 1.5,
  backgroundColor: "#fff",
  color: "#637381",
  borderColor: "rgba(145, 158, 171, 0.24)",
  fontFamily: "Poppins",
  fontWeight: 500,
  maxHeight:'52px',
  "&:hover": {
    backgroundColor: "#fff",
    borderColor: "#37B34A",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#fff",
    borderColor: "#37B34AB5",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem #37B34AB5",
  },
});

const renderTags = (value, getTagProps) => {
  const tagsLimit = 1;
  if (value.length <= tagsLimit) {
    return value.map((option, index) => (
      <Chip key={option} label={option} {...getTagProps({ index })} />
    ));
  }

  const displayedTags = value.slice(0, tagsLimit);
  const remainingTagsCount = value.length - tagsLimit;

  return (
    <>
      {displayedTags.map((option, index) => (
        <Chip key={option} label={option} {...getTagProps({ index })} />
      ))}
      <Tooltip title={`${value.slice(1, 100)} `} arrow>
        <Chip label={`+${remainingTagsCount}`} />
      </Tooltip>
    </>
  );
};

const DistanceFilter = (props) => {
  const {
    distanceFilterObj,
    distanceFilterCheck,
    setDistnaceFilterCheck,
    selectDistrict,
    setSelectDistrict,
    selectCounty,
    setSelectCounty,
    distance,
    setDistance,
    settingComponent = false,
    handleDistanceChange,
    onAdd,
    onSubtract,
    t,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleOrderChange = (event) => {
  //   if (settingComponent) {
  //     for (let prop in distanceFilterObj) {
  //       distanceFilterObj[prop] = false;
  //     }
  //     distanceFilterObj[event.target.name] = true;
  //     setDistnaceFilterCheck({
  //       ...distanceFilterObj,
  //     });
  //   } else {
  //     setDistnaceFilterCheck({
  //       ...distanceFilterObj,
  //       [event.target.name]: event.target.checked,
  //     });
  //   }
  // };
const handleOrderChange = (event) => {
  const { name, checked } = event.target;

  if (settingComponent) {
    setDistnaceFilterCheck({
      offerDistance: false,
      location: false,
      [name]: true
    });
  } else {
    setDistnaceFilterCheck(prev => ({
      ...prev,
      [name]: checked
    }));
  }
};
  // const handleDistanceChange = (event) => {
  //   setDistance(event.target.value < 1 ? 1 : event.target.value);
  // };

  // const onAdd = () => {
  //   setDistance((prev) => Number(prev) + 1);
  // };

  // const onSubtract = () => {
  //   setDistance((prev) => (prev === 1 || prev === 0 ? 1 : Number(prev) - 1));
  // };

  React.useEffect(() => {
    if (!settingComponent) {
      if (distanceFilterCheck.location) {
        setSelectDistrict(null);
        setSelectCounty(null);
      } else {
        setDistance(1);
      }
    }
  }, [distanceFilterCheck, settingComponent]);

  return (
    <div>
      {!settingComponent && (
        <>
          <BootstrapButton
            id="demo-customized-button"
            aria-controls={open ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            endIcon={<ExpandCircleDownOutlinedIcon />}
          >
            {t("distance")}{" "}
            <Chip
              sx={{
                backgroundColor: distanceFilterCheck.offerDistance
                  ? "#E4F2E8"
                  : "transparent",
                color: "#1B727E",
                m: "5px",
                "& .MuiChip-label": { fontWeight: "bold" },
              }}
              label={distanceFilterCheck.offerDistance ? `${distance} km` : ""}
              size={"medium"}
              component="span"
            />
          </BootstrapButton>
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <Stack
              direction={"row"}
              alignItems={"flex-start"}
              sx={{ width: "100%" }}
              gap={1}
            >
              <FormControl
                component="fieldset"
                variant="standard"
                sx={{ width: "100%" }}
              >
                <FormLabel
                  component="legend"
                  sx={{ ml: "24px", mt: 1, textTransform: "uppercase",fontWeight:600,fontSize:"12px" }}
                >
                  {t("proximityOffers")}
                </FormLabel>
                <FormGroup sx={{ width: "100%", flexDirection: "row" }}>
                  {Object.keys(distanceFilterObj).map((item) => (
                    <MenuItem
                      key={item}
                      disableRipple
                      sx={{ justifyContent: "space-between" }}
                    >
                      <FormControlLabel
                        labelPlacement="end"
                        control={
                          <Checkbox
                            name={item}
                            checked={distanceFilterCheck[item]}
                            onChange={handleOrderChange}
                            inputProps={{ "aria-label": "controlled" }}
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CheckCircleIcon />}
                            sx={{
                              p: 0,
                              m: 0,
                              mr: 1,
                              justifyContent: "space-between",
                              "& .MuiSvgIcon-root": {
                                fontSize: "28px !important",
                                color: "#37B34A !important",
                                mr: "0px !important",
                              },
                            }}
                          />
                        }
                        sx={{
                          width: 1,
                          justifyContent: "space-between",
                          ml: "4px",
                          mr: 1,
                        }}
                        label={<Typography sx={{fontWeight:600}}>{t(`${item}`)}</Typography>}
                      />
                    </MenuItem>
                  ))}
                </FormGroup>
                {distanceFilterCheck.offerDistance && (
                  <FormGroup>
                    <FormLabel
                      component="legend"
                      sx={{
                        ml: "24px",
                        mt: 1,
                        fontSize: "small",
                        fontWeight:600
                      }}
                    >
                      {t("setDistance")}
                    </FormLabel>
                    <MenuItem disableRipple sx={{ width: 1 }}>
                      <ButtonGroup
                        variant="outlined"
                        aria-label="outlined button group"
                      >
                        <Button onClick={onSubtract}>-</Button>
                        <input
                          type="number"
                          style={{
                            width: "50px",
                            textAlign: "center",
                            fontSize: "14px",
                            border: "0.5px solid #37B34A",
                          }}
                          value={distance}
                          onChange={handleDistanceChange}
                          min={1}
                          // readOnly
                        />
                        <Button onClick={onAdd}>+</Button>
                      </ButtonGroup>
                    </MenuItem>
                  </FormGroup>
                )}
                {distanceFilterCheck.location && (
                  <FormGroup>
                    <FormLabel
                      component="legend"
                      sx={{
                        ml: "24px",
                        mt: 1,
                        fontSize: "small",
                        fontWeight:600
                      }}
                    >
                      {t("selectLocation")}
                    </FormLabel>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: 1,
                        justifyContent: "space-between",
                        flexDirection: responsiveValue(
                          "",
                          "",
                          "",
                          "row",
                          "row",
                          "column"
                        ),
                      }}
                    >
                      <MenuItem
                        disableRipple
                        sx={{ justifyContent: "space-between", width: 1 }}
                      >
                        <Autocomplete
                          noOptionsText={t('noOptionsText')}
                          disablePortal
                          defaultValue={""}
                          // options={AddressData.map((item) => item.district)}
                          options={AddressData.map((item) => item.district).sort((a, b) => a.localeCompare(b, 'pt-PT'))}
                          sx={{
                            width: 1,
                          }}
                          value={selectDistrict !== null ? selectDistrict : ""}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          onChange={(event, value) => {
                            setSelectDistrict(value);
                            setSelectCounty([]);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label={t("district")} />
                          )}
                        />
                      </MenuItem>
                      <MenuItem
                        disableRipple
                        sx={{ justifyContent: "space-between", width: 1 }}
                      >
                        <Autocomplete
                          noOptionsText={t('noOptionsText')}
                          // disablePortal
                          multiple
                          limitTags={1}
                          defaultValue={""}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          // options={
                          //   selectDistrict
                          //     ? [
                          //         "Todos",
                          //         ...AddressData.find(
                          //           ({ district }) =>
                          //             district === selectDistrict
                          //         ).county.map((county) => county.countyName),
                          //       ]
                          //     : []
                          // }
                          options={
                            selectDistrict
                              ? [
                                  "Todos",
                                  ...AddressData.find(({ district }) => district === selectDistrict)
                                    .county.map((county) => county.countyName).sort((a, b) => a.localeCompare(b, 'pt-BR'))
                                ]
                              : []
                          }
                          sx={{
                            width: "100%", 
                            display: "flex",
                            flexWrap: "wrap",
                            // height: "100px",
                            // overflow: "scroll",
                            alignItems: "center",
                            // ".MuiAutocomplete-inputRoot" :{
                            //   flexWrap: "nowrap !important"
                            // }
                          }}
                          getOptionLabel={(option) => (option ? option : "")}
                          value={selectCounty !== null ? selectCounty : ""}
                          onChange={(event, value, reason) => {
                            let allData = AddressData.find(
                              ({ district }) => district === selectDistrict
                            ).county.map((county) => county.countyName);
                            if (
                              reason === "removeOption" &&
                              selectCounty.find(
                                (select) => select === "Todos"
                              ) &&
                              value.find((select) => select === "Todos")
                            ) {
                              setSelectCounty([
                                ...value.filter((select) => select !== "Todos"),
                              ]);
                            } else if (
                              reason === "removeOption" &&
                              selectCounty.find(
                                (select) => select === "Todos"
                              ) &&
                              value.find((select) => select !== "Todos")
                            ) {
                              setSelectCounty([]);
                            } else if (
                              reason === "selectOption" &&
                              value.find((v) => v === "Todos")
                            ) {
                              setSelectCounty(["Todos", ...allData]);
                            } else if (
                              reason === "selectOption" &&
                              value.length === allData.length
                            ) {
                              setSelectCounty(["Todos", ...allData]);
                            } else {
                              setSelectCounty(value);
                            }
                          }}
                          renderTags={renderTags}
                          renderInput={(params) => (
                            <TextField {...params} label={t("county")} />
                          )}
                        />
                      </MenuItem>
                    </Box>
                  </FormGroup>
                )}
              </FormControl>
            </Stack>
          </StyledMenu>{" "}
        </>
      )}
      {settingComponent && (
        <Stack
          direction={"row"}
          alignItems={"flex-start"}
          sx={{ width: "100%" }}
          gap={1}
        >
          <FormControl
            component="fieldset"
            variant="standard"
            sx={{ width: "100%" }}
          >
            <FormGroup sx={{ width: "100%", flexDirection: "row" }}>
              {Object.keys(distanceFilterObj).map((item) => (
                <MenuItem
                  key={item}
                  disableRipple
                  sx={{ justifyContent: "space-between" }}
                >
                  <FormControlLabel
                    labelPlacement="start"
                    control={
                      <Checkbox
                        name={item}
                        checked={distanceFilterCheck[item]}
                        onChange={handleOrderChange}
                        inputProps={{ "aria-label": "controlled" }}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<CheckCircleIcon />}
                        sx={{
                          p: 0,
                          m: 0,
                          ml: 2,
                          justifyContent: "space-between",
                          "& .MuiSvgIcon-root": {
                            fontSize: "28px !important",
                            color: "#37B34A !important",
                            mr: "0px !important",
                          },
                        }}
                      />
                    }
                    sx={{
                      width: 1,
                      justifyContent: "space-between",
                      ml: "10px",
                      mr: 1,
                    }}
                    label={t(`${item}`)}
                  />
                </MenuItem>
              ))}
            </FormGroup>
            {distanceFilterCheck.offerDistance && (
              <FormGroup>
                <FormLabel
                  component="legend"
                  sx={{
                    ml: "24px",
                    mt: 1,
                    fontSize: "small",
                  }}
                >
                  {t("setDistance")}
                </FormLabel>
                <MenuItem disableRipple sx={{ width: 1 }}>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="outlined button group"
                  >
                    <Button onClick={onSubtract}>-</Button>
                    <input
                      type="number"
                      style={{
                        width: "50px",
                        textAlign: "center",
                        fontSize: "14px",
                        border: "0.5px solid #37B34A",
                      }}
                      value={distance}
                      onChange={handleDistanceChange}
                      min={1}
                      // readOnly
                    />
                    <Button onClick={onAdd}>+</Button>
                  </ButtonGroup>
                </MenuItem>
              </FormGroup>
            )}
            {distanceFilterCheck.location && (
              <FormGroup>
                <FormLabel
                  component="legend"
                  sx={{
                    ml: "24px",
                    mt: 1,
                    fontSize: "small",
                  }}
                >
                  {t("selectLocation")}
                </FormLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: 1,
                    justifyContent: "space-between",
                    flexDirection: responsiveValue(
                      "",
                      "",
                      "",
                      "row",
                      "row",
                      "column"
                    ),
                  }}
                >
                  <MenuItem
                    disableRipple
                    sx={{ justifyContent: "space-between", width: 1 }}
                  >
                    <Autocomplete
                      noOptionsText={t('noOptionsText')}
                      disablePortal
                      defaultValue={""}
                      // options={AddressData.map((item) => item.district)}
                      options={AddressData.map((item) => item.district).sort((a, b) => a.localeCompare(b, 'pt-PT'))}
                      sx={{
                        width: 1,
                        marginTop: "20px",
                      }}
                      value={selectDistrict !== null ? selectDistrict : ""}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={(event, value) => {
                        setSelectDistrict(value);
                        setSelectCounty([]);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={t("district")} />
                      )}
                    />
                  </MenuItem>
                  <MenuItem
                    disableRipple
                    sx={{ justifyContent: "space-between", width: 1 }}
                  >
                    <Autocomplete
                      noOptionsText={t('noOptionsText')}
                      // disablePortal
                      multiple
                      limitTags={1}
                      defaultValue={""}
                      isOptionEqualToValue={(option, value) => option === value}
                      // options={
                      //   selectDistrict
                      //     ? [
                      //         "Todos",
                      //         ...AddressData.find(
                      //           ({ district }) => district === selectDistrict
                      //         ).county.map((county) => county.countyName),
                      //       ]
                      //     : []
                      // }
                      options={
                        selectDistrict
                          ? [
                              "Todos",
                              ...AddressData.find(
                                ({ district }) => district === selectDistrict
                              ).county.map((county) => county.countyName).sort((a, b) => a.localeCompare(b, 'pt-PT')),
                            ]
                          : []
                      }
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        marginTop: "20px",
                        // ".MuiAutocomplete-inputRoot" :{
                        //   flexWrap: "nowrap !important"
                        // }
                      }}
                      getOptionLabel={(option) => (option ? option : "")}
                      value={selectCounty !== null ? selectCounty : ""}
                      onChange={(event, value, reason) => {
                        // ;
                        let allData = AddressData.find(
                          ({ district }) => district === selectDistrict
                        ).county.map((county) => county.countyName);
                        if (
                          reason === "removeOption" &&
                          selectCounty.find((select) => select === "Todos") &&
                          value.find((select) => select === "Todos")
                        ) {
                          setSelectCounty([
                            ...value.filter((select) => select !== "Todos"),
                          ]);
                        } else if (
                          reason === "removeOption" &&
                          selectCounty.find((select) => select === "Todos") &&
                          value.find((select) => select !== "Todos")
                        ) {
                          setSelectCounty([]);
                        } else if (
                          reason === "selectOption" &&
                          value.find((v) => v === "Todos")
                        ) {
                          setSelectCounty(["Todos", ...allData]);
                        } else if (
                          reason === "selectOption" &&
                          value.length === allData.length
                        ) {
                          setSelectCounty(["Todos", ...allData]);
                        } else {
                          setSelectCounty(value);
                        }
                      }}
                      renderTags={renderTags}
                      renderInput={(params) => (
                        <TextField {...params} label={t("county")} />
                      )}
                    />
                  </MenuItem>
                </Box>
              </FormGroup>
            )}
          </FormControl>
        </Stack>
      )}
    </div>
  );
};

DistanceFilter.propTypes = {
  t: PropTypes.func,
  distanceFilterObj: PropTypes.object,
  distanceFilterCheck: PropTypes.object,
  setDistnaceFilterCheck: PropTypes.func,
  selectDistrict: PropTypes.any,
  setSelectDistrict: PropTypes.func,
  selectCounty: PropTypes.any,
  setSelectCounty: PropTypes.func,
  distance: PropTypes.number,
  setDistance: PropTypes.func,
};

export default DistanceFilter;
